import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";

import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { CertificateService } from "@services/certificate.service";
import { CompanyService } from "@services/company.service";
import { ModalService } from "@services/modal.service";
import { EMPTY } from "rxjs";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { UserActions } from "../actions/user.actions";

@Injectable()
export class UserEffects {
  loadNFCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadToken),
      switchMap((action) =>
        this.companyService.fetchNfCompany(action.token).pipe(
          tap((company) => {
            if (company?.cnpj) {
              return;
            }

            this.modalService.info(
              "Os dados da empresa ainda não foram cadastrados. Para emitir NF-e ou NFS-e, finalize o cadastro no Painel do Contador.",
              "Cadastro da empresa pendente",
              () => {
                this.router.navigate(["settings"], {
                  queryParams: {
                    tab: 0
                  }
                });
              }
            );
          }),
          map((company) =>
            UserActions.loadNFCompany({
              company
            })
          ),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 404) {
              this.modalService.info(
                "Você ainda não cadastrou os dados da sua empresa. Cadastre seus dados agora para começar a emitir notas fiscais!",
                "Finalize o preenchimento dos seus dados!",
                () => {
                  this.router.navigate(["settings"]);
                }
              );

              return EMPTY;
            }

            this.modalService.error(error.error.message);
            return EMPTY;
          })
        )
      )
    );
  });

  loadPNCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadNFCompany),
      switchMap(() => {
        return this.companyService.fetchPNCompany().pipe(
          map((company) =>
            UserActions.loadPNCompany({
              company
            })
          ),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 404) {
              return EMPTY;
            }

            this.modalService.error(
              error?.error?.message?.message ??
                error?.error?.message ??
                error?.message ??
                "Não foi possível carregar os dados da empresa."
            );
            return EMPTY;
          })
        );
      })
    );
  });

  loadCertficate$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadPNCompany),
      switchMap((action) => {
        if (action.company.certificado) {
          return this.certificateService.fetch(action.company.certificado).pipe(
            map((certificate) =>
              UserActions.loadCertificate({
                certificate
              })
            ),
            catchError(() => EMPTY)
          );
        }

        return EMPTY;
      })
    );
  });

  loadLimits$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserActions.loadNFCompany),
      switchMap(() => {
        return this.companyService.fetchlimits().pipe(
          map((limits) =>
            UserActions.loadLimits({
              limits
            })
          ),
          catchError(() => EMPTY)
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private companyService: CompanyService,
    private router: Router,
    private certificateService: CertificateService,
    private modalService: ModalService
  ) {}
}
